module.exports = __webpack_public_path__ + "img/property-mortgage.svg";